import { useEffect } from "react";
import { dispatchInAppEvent } from "../utils/events";
const usePageVisitedEvent = (page) => {
    useEffect(() => {
        dispatchInAppEvent(`${page}_PAGE_VISITED`);
    }, [page]);
};
export default usePageVisitedEvent;
